<template>
  <div class="simple-filter-expression">
    <div class="simple-expression" v-bind:class="definition.classes">
      <!--<label v-if="definition.isList">{{ definition.title }}</label>-->

      <div class="arg" v-if="definition.isList" v-for="(arg, argId) in expression.args">
        <FilterExpression :expression="arg" @update:expression="setArg(argId, $event)" :columns="columns"
                           :parent="definition" @delete="deleteArg(argId)"></FilterExpression>
      </div>

      <button class="mdl-button add-button" v-if="definition.isList" v-on:click="addArg">
        <i  class="material-icons">add</i> Add
      </button>

    </div>
  </div>
</template>

<script>
import expression from "../../logic/expression.js"

import FilterExpression from "./FilterExpression"
import SimpleFilterAndBlock from "./SimpleFilterAndBlock"

export default {
  name: 'filter-expression',
  props: {
    columns: {
      type: Array,
      default: function () {
        return []
      }
    },
    expression: {
      type: Object,
      default: function() {
        return {
          type: "and",
          args: []
        }
      }
    },
    parent: {
      type: Object,
      default: function() {
        return null
      }
    }
  },
  components: {
    FilterExpression: SimpleFilterAndBlock
  },
  data () {
    return {

    }
  },
  computed: {
    definition() {
      return expression.operatorsByName.get(this.expression.type)
    },
    possibleOperators() {
      /// TODO: filter operators by parent element type
      return expression.operators
    }
  },
  watch: {
  },
  methods: {
    operatorDefinition(expr) {
      const operator = expression.operatorsByName.get(expr.type)
      console.log("OP", operator)
      return operator
    },
    addArg() {
      var narg = {
        "type": "and",
        args: [
          {
            "type": "or",
            args: [
              {
                "type": ">",
                "args": ["Count", 100]
              }
            ]
          }
        ]
      }
      this.$emit('update:expression', {
        type: this.expression.type,
        args: this.expression.args.concat([narg])
      })
    },
    setArg(argId, ev) {
      console.log("SET ARG", argId, ev)
      const nArgs = this.expression.args.slice()
      nArgs[argId] = ev
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    deleteArg(argId) {
      console.log("DELETE ARG", argId)
      const nArgs = this.expression.args.slice()
      nArgs.splice(argId, 1)
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    deleteThis() {
      this.$emit('delete')
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*.expression {
    border: 1px solid rgba(0,0,0,0.4);
  }*/

  .simple-expression > button {
    display: block;
    font-size: 0.77em;
    height: 2em;
    line-height: 2em
  }

  .simple-expression > button i {
    font-size: 1.23em;
    line-height: 0.77em;
  }
  .simple-expression > .delete-button {
    display: inline-block;
    font-size: 0.77em;
    line-height: 1em;
    position: relative;
    top: -2px
  }


</style>



// WEBPACK FOOTER //
// SimpleFilterExpression.vue?5b07b610